import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import localeData from "dayjs/plugin/localeData";
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonRow,
} from "@ionic/react";

import { callSharp, logoWhatsapp } from "ionicons/icons";
import CustomDesplegable from "../../components/basicsComponents/CustomDesplegable/CustomDesplegable";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  borrarObjetosDuplicados,
  ordenarArrayObjetosByDate,
} from "../../utils/funcionalidadesArrays";
import {
  HoraDentrodelLimite,
  obtenerNombreDia,
  parseHorario,
} from "../../utils/funcionalidadesStrings";
import { obtenerNotaWebMutual } from "../../utils/mutuales";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import CustomCalendar from "../../components/basicsComponents/Calendar";
import { Typography } from "@mui/joy";
import useTituloPagina from "../../hooks/tituloPagina";
import "./NuevoTurno.css";
var weekOfYear = require("dayjs/plugin/weekOfYear");

dayjs.extend(weekOfYear);
dayjs.locale("es");
dayjs.extend(localeData);

// Cache/dedup para evitar llamadas repetidas al endpoint pesado
// TurnosPrestadorFechaXDia con los mismos parametros.
const TURNOS_X_DIA_CACHE_TTL_MS = 2 * 60 * 1000;
const turnosPrestadorFechaXDiaCache = new Map();

const obtenerTurnosPrestadorFechaXDia = async ({
  url,
  mutual,
  desde,
  hasta,
  config,
}) => {
  const key = `${url}|${mutual}|${desde}|${hasta}`;
  const ahora = Date.now();
  const cacheEntry = turnosPrestadorFechaXDiaCache.get(key);

  if (cacheEntry) {
    if (
      cacheEntry.data &&
      ahora - cacheEntry.timestamp < TURNOS_X_DIA_CACHE_TTL_MS
    ) {
      return cacheEntry.data;
    }
    if (cacheEntry.promise) {
      return cacheEntry.promise;
    }
  }

  const requestPromise = axios
    .get(
      `${url}Turnos/TurnosPrestadorFechaXDia/?mutual=${mutual}&desde=${desde}&hasta=${hasta}`,
      config,
    )
    .then((response) => {
      const data = Array.isArray(response.data) ? response.data : [];
      turnosPrestadorFechaXDiaCache.set(key, {
        data,
        timestamp: Date.now(),
      });
      return data;
    })
    .catch((error) => {
      turnosPrestadorFechaXDiaCache.delete(key);
      throw error;
    });

  turnosPrestadorFechaXDiaCache.set(key, {
    promise: requestPromise,
    timestamp: ahora,
  });

  return requestPromise;
};

export default function NuevoTurno() {
  const MOSTRAR_TODOS_ESPECIALIDADES = "__MOSTRAR_TODOS_ESPECIALIDADES__";
  const diasSemana = [
    "domingo",
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
  ];
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [especialidades, setEspecialidades] = useState([]);
  const [horariosPrestadores, setHorariosPrestadores] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [
    prestadorSeleccionadoExternamente,
    setPrestadorSeleccionadoExternamente,
  ] = useState(false);
  const [fechasFuturas, setFechasFuturas] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [turnosPaciente, setTurnosPaciente] = useState([]);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [mostrarInasisEspecilidad, setMostrarInasisEspecilidad] =
    useState(false);
  const [mostrarTurnoPrestadorReservado, setMostrarTurnoPrestadorReservado] =
    useState(false);
  const [abrirDesplegableEspecialidades, setAbrirDesplegableEspecialidades] =
    useState(false);
  const [abrirDesplegablePrestadores, setAbrirDesplegablePrestadores] =
    useState(false);

  const [abrirModalConfirmarReserva, setAbrirModalConfirmarReserva] =
    useState(false);
  const [abrirModalPostReserva, setAbrirModalPostReserva] = useState(false);
  const [notaWebMutual, setNotaWebMutual] = useState("");
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const inicioCargadoRef = useRef(false);

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();

  useTituloPagina();
  const prestadorActual =
    prestadores.find(
      (prestador) => prestador.codigo === prestadorSeleccionado,
    ) || null;
  const mostrarNotaWebMutual =
    especialidadSeleccionada !== -1 &&
    prestadorSeleccionado !== -1 &&
    notaWebMutual !== "" &&
    !mostrarInasisEspecilidad &&
    !mostrarTurnoPrestadorReservado;
  const mostrarNotaWebPrestador =
    prestadorSeleccionado !== -1 &&
    Boolean(prestadorActual?.notaWeb) &&
    !mostrarInasisEspecilidad &&
    !mostrarTurnoPrestadorReservado;
  const especialidadVisibleEnSelector =
    especialidadSeleccionada === MOSTRAR_TODOS_ESPECIALIDADES &&
    prestadorActual?.especialidad
      ? prestadorActual.especialidad
      : especialidadSeleccionada;
  const construirNotaProximoTurno = (fechaProximoTurno) => {
    if (!fechaProximoTurno) return "";
    return `Proximo turno: ${obtenerNombreDia(
      dayjs(fechaProximoTurno).format("dddd"),
    )} ${dayjs(fechaProximoTurno).format("DD")} de ${dayjs(
      fechaProximoTurno,
    ).format("MMMM, YYYY")}`;
  };

  const obtenerFotoPrestador = (prestador = {}) => {
    const camposFoto = [
      "foto",
      "Foto",
      "fotoWeb",
      "FotoWeb",
      "imagen",
      "Imagen",
      "imagenWeb",
      "ImagenWeb",
      "fotoBase64",
      "FotoBase64",
      "imagenBase64",
      "ImagenBase64",
    ];
    const campoFoto = camposFoto.find(
      (campo) => prestador?.[campo] !== undefined && prestador?.[campo] !== null,
    );
    const foto = campoFoto ? prestador[campoFoto] : "";

    if (typeof foto !== "string" || foto.trim() === "") {
      return "";
    }

    const fotoNormalizada = foto.trim();
    if (
      fotoNormalizada.startsWith("data:") ||
      fotoNormalizada.startsWith("http://") ||
      fotoNormalizada.startsWith("https://")
    ) {
      return fotoNormalizada;
    }

    const fotoBase64 = fotoNormalizada.replace(/\s/g, "");
    const mimeType = obtenerMimeFotoPrestador(fotoBase64);

    return `data:${mimeType};base64,${fotoBase64}`;
  };

  const obtenerMimeFotoPrestador = (fotoBase64) => {
    if (fotoBase64.startsWith("Qk")) return "image/bmp";
    if (fotoBase64.startsWith("/9j/")) return "image/jpeg";
    if (fotoBase64.startsWith("iVBOR")) return "image/png";
    if (fotoBase64.startsWith("R0lG")) return "image/gif";
    if (fotoBase64.startsWith("UklGR")) return "image/webp";

    return "image/jpeg";
  };

  const obtenerNombreEspecialidadPrestador = (prestador) => {
    const especialidadPrestador = especialidades.find(
      (especialidad) => especialidad.codigo === prestador.especialidad,
    );
    return especialidadPrestador?.nombre || "";
  };

  const formatearTextoPrestador = (prestador, incluirEspecialidad = false) => {
    if (!incluirEspecialidad) return prestador.nombre;

    const nombreEspecialidad = obtenerNombreEspecialidadPrestador(prestador);
    if (!nombreEspecialidad) return prestador.nombre;

    return `${prestador.nombre} - ${nombreEspecialidad}`;
  };

  const formatearPrestadores = (
    prestadores,
    proximosTurnosPorPrestador = new Map(),
  ) => {
    return prestadores.map((prestador) => {
      const fechaProximoTurno =
        proximosTurnosPorPrestador.get(prestador.codigo) || null;
      return {
        ...prestador,
        text: prestador.nombre,
        imageSrc: obtenerFotoPrestador(prestador),
        fechaProximoTurno,
        note: construirNotaProximoTurno(fechaProximoTurno),
        notaWeb: prestador.notaWeb ? prestador.notaWeb : "",
      };
    });
  };

  const filtrarPrestadoresPorEspecialidad = (prestadoresBase, especialidad) => {
    if (especialidad === MOSTRAR_TODOS_ESPECIALIDADES) {
      return ordenarPrestadoresPorProximoTurno(prestadoresBase).map(
        (prestador) => ({
          ...prestador,
          text: formatearTextoPrestador(prestador, true),
          imageSrc: prestador.imageSrc || obtenerFotoPrestador(prestador),
        }),
      );
    }

    return ordenarPrestadoresPorProximoTurno(
      prestadoresBase.filter(
        (prestador) =>
          prestador.especialidad === especialidad ||
          prestador.especialidad2 === especialidad ||
          prestador.especialidad3 === especialidad,
      ),
    ).map((prestador) => ({
      ...prestador,
      text: formatearTextoPrestador(prestador, true),
      imageSrc: prestador.imageSrc || obtenerFotoPrestador(prestador),
    }));
  };

  const obtenerPrimerosProximosTurnos = async (paciente) => {
    let turnos = [];
    let turnosDisponibles = [];
    const proximosTurnosPorPrestador = new Map();
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    const url = localStorage.getItem("urlAxioPP");

    try {
      const desde = dayjs().add(1, "day").format("YYYY/MM/DD HH:mm");
      const hasta = dayjs().add(3, "month").format("YYYY/MM/DD HH:mm");
      turnos = await obtenerTurnosPrestadorFechaXDia({
        url,
        mutual: paciente.mutual,
        desde,
        hasta,
        config,
      });

      turnosDisponibles = ordenarArrayObjetosByDate(turnos, "fecha");

      turnosDisponibles.forEach((turno) => {
        if (
          turno.prestador &&
          !proximosTurnosPorPrestador.has(turno.prestador)
        ) {
          proximosTurnosPorPrestador.set(turno.prestador, turno.fecha);
        }
      });
    } catch (error) {
      throw new Error("Error al obtener los turnos futuros: " + error.message);
    }
    return proximosTurnosPorPrestador;
  };

  const cargarProximosTurnosPrestadores = async (paciente, prestadoresBase) => {
    if (!prestadoresBase || prestadoresBase.length === 0) return;

    try {
      const proximosTurnosPorPrestador =
        await obtenerPrimerosProximosTurnos(paciente);
      const prestadoresActualizados = formatearPrestadores(
        prestadoresBase,
        proximosTurnosPorPrestador,
      );

      setPrestadores(prestadoresActualizados);
      setListadoPrestadores((listadoActual) => {
        if (especialidadSeleccionada !== -1) {
          return filtrarPrestadoresPorEspecialidad(
            prestadoresActualizados,
            especialidadSeleccionada,
          );
        }

        const codigosActuales = new Set(
          listadoActual.map((prestador) => prestador.codigo),
        );
        if (codigosActuales.size === 0) {
          return ordenarPrestadoresPorProximoTurno(prestadoresActualizados);
        }

        const prestadoresEnVista = prestadoresActualizados.filter((prestador) =>
          codigosActuales.has(prestador.codigo),
        );
        return ordenarPrestadoresPorProximoTurno(prestadoresEnVista);
      });
    } catch (error) {
      console.warn(
        "No se pudieron cargar los proximos turnos de prestadores:",
        error,
      );
    }
  };

  const traerPrestadores = async (paciente) => {
    let prestadores = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config,
      );

      if (response.data.length !== 0) {
        prestadores = response.data;
      }

      prestadores = prestadores.filter(
        (prestador) => prestador.vigente === true,
      );

      /* SE SACA RESTRICCION DE EDAD PARA MOSTRAR TODOS LOS PRESTADORES YA QUE HAY PRESTADORES PEDIATRICOS QUE ATIENEN MAYORES DE 15 AÑOS Y SE QUERIA MOSTRAR TODOS LOS PRESTADORES CON LA ESPECIALIDAD PEDIATRIA INDEPENDIENTEMENTE DE LA EDAD DEL PACIENTE
      let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");

      prestadores = prestadores.filter((prestador) => {
        if (prestador.filtroEdad) {
          if (prestador.edadDesde <= edad && edad <= prestador.edadHasta)
            return prestador;
        } else {
          return prestador;
        }
      });

      if (edad <= 15) {
        prestadores = prestadores.filter((prestador) =>
          [125, 115, 124].includes(prestador.especialidad)
        );
      } else {
        prestadores = prestadores.filter(
          (prestador) => ![125, 115].includes(prestador.especialidad)
        );
      }*/

      prestadores = formatearPrestadores(prestadores);

      setPrestadores(prestadores);
      setListadoPrestadores(prestadores);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar los prestadores registrados en el sistema",
        "rojo",
      );
    }
    return prestadores;
  };

  const traerEspecialidades = async (paciente, prestadoresDisponibles) => {
    let especialidades = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Especialidades`, config);
      if (response.data.length !== 0) {
        especialidades = response.data;
      } else {
        especialidades = null;
      }
      especialidades = especialidades.filter(
        (especialidad) => especialidad.vigente === true,
      );

      const especialidadesMostrables = [];
      prestadoresDisponibles.forEach((prestador) => {
        const valor = prestador.especialidad;
        if (!especialidadesMostrables.includes(valor)) {
          especialidadesMostrables.push(valor);
        }
      });

      const especialidadesCoincidentes = [];
      especialidades.forEach((especialidad) => {
        if (especialidadesMostrables.includes(especialidad.codigo)) {
          especialidadesCoincidentes.push(especialidad);
        }
      });
      especialidades = especialidadesCoincidentes;
      especialidades = especialidades.map((especialidad) => {
        return {
          ...especialidad,
          text: especialidad.nombre,
        };
      });

      setEspecialidades(especialidades);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar las especialidades registradas en el sistema",
        "rojo",
      );
    }
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnos = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config,
        );
        if (response.data.length !== 0) {
          turnos = response.data;
          turnos = turnos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnos = turnos.slice(0, 5);
        } else {
          turnos = [];
        }

        setTurnosPaciente(turnos);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus proximos turnos",
        "rojo",
      );
    }
  };

  const CargarDesplegables = async (sesion) => {
    let prestadoresDisponibles = await traerPrestadores(sesion);
    await traerEspecialidades(sesion, prestadoresDisponibles);
    return prestadoresDisponibles;
  };

  const traerNotaWebMutualPaciente = async (paciente) => {
    const url = localStorage.getItem("urlAxioPP");

    try {
      const notaWeb = await obtenerNotaWebMutual(
        url,
        paciente.token,
        paciente.mutual,
      );
      setNotaWebMutual(notaWeb);
    } catch (error) {
      setNotaWebMutual("");
    }
  };

  useEffect(() => {
    if (inicioCargadoRef.current) {
      return;
    }
    inicioCargadoRef.current = true;

    const inicializarDatos = async () => {
      setCargando(true);
      try {
        const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
        if (sesion) {
          const [, prestadoresDisponibles] = await Promise.all([
            traerTurnosPaciente(sesion),
            CargarDesplegables(sesion),
            traerNotaWebMutualPaciente(sesion),
          ]);
          cargarProximosTurnosPrestadores(sesion, prestadoresDisponibles);

          setUsuario(sesion);
          setUrlAxio(localStorage.getItem("urlAxioPP"));
          setTituloPagina(localStorage.getItem("nombreClinica"));
          document.title = localStorage.getItem("tituloWeb");

          if (history.location.state?.prestador) {
            setPrestadorSeleccionadoExternamente(true);
          }
        }
      } catch (e) {
        history.push({ pathname: "/ErrorPage" });
      } finally {
        setCargando(false);
      }
    };

    inicializarDatos();
  }, []);

  useEffect(() => {
    const cargarDatos = async () => {
      if (horariosPrestadores.length > 0 && usuario.codigo) {
        setCargando(true);
        try {
          const prestadoresDisponibles = await CargarDesplegables(usuario);
          cargarProximosTurnosPrestadores(usuario, prestadoresDisponibles);
        } finally {
          setCargando(false);
        }
      }
    };

    cargarDatos();
  }, [horariosPrestadores, usuario]);

  useEffect(() => {
    if (
      !abrirDesplegableEspecialidades &&
      especialidadSeleccionada !== -1 &&
      !prestadorSeleccionadoExternamente &&
      prestadorSeleccionado === -1 &&
      fechasFuturas.length === 0
    ) {
      setAbrirDesplegablePrestadores(true);
    }
  }, [
    abrirDesplegableEspecialidades,
    especialidadSeleccionada,
    prestadorSeleccionadoExternamente,
    prestadorSeleccionado,
    fechasFuturas,
  ]);

  useEffect(() => {
    if (
      especialidades.length > 0 &&
      especialidadSeleccionada === -1 &&
      !cargando &&
      !prestadorSeleccionadoExternamente
    ) {
      setAbrirDesplegableEspecialidades(true);
    }
  }, [
    especialidades,
    especialidadSeleccionada,
    cargando,
    prestadorSeleccionadoExternamente,
  ]);

  useEffect(() => {
    const manejarPrestadorPreseleccionado = async () => {
      if (
        especialidades.length > 0 &&
        prestadores.length > 0 &&
        prestadorSeleccionado === -1 &&
        history.location.state?.prestador !== undefined &&
        history.location.state?.prestador !== null &&
        !cargando
      ) {
        const prestadorCodigo = history.location.state.prestador;

        const prestadorEncontrado = prestadores.find(
          (prestador) => prestador.codigo === prestadorCodigo,
        );

        if (prestadorEncontrado) {
          const especialidadPrestador = prestadorEncontrado.especialidad;
          setEspecialidadSeleccionada(especialidadPrestador);

          const prestadoresFiltrados = prestadores.filter(
            (prestador) =>
              prestador.especialidad === especialidadPrestador ||
              prestador.especialidad2 === especialidadPrestador,
          );

          const prestadoresOrdenados =
            ordenarPrestadoresPorProximoTurno(prestadoresFiltrados);
          setListadoPrestadores(prestadoresOrdenados);

          setPrestadorSeleccionado(prestadorCodigo);

          setAbrirDesplegableEspecialidades(false);
          setAbrirDesplegablePrestadores(false);

          const inasistencias = verificarInasistenciasPorEspecialidad(
            especialidadPrestador,
          );

          if (inasistencias <= 1) {
            const turnoPendiente =
              verificarTurnoConPrestadorPendiente(prestadorCodigo);

            if (!turnoPendiente) {
              mostrarNotificacion(
                true,
                `Cargando horarios disponibles para ${prestadorEncontrado.nombre}...`,
                "verde",
              );
              traerHorariosAtencion(prestadorCodigo);
            } else {
            }
          } else {
          }
        } else {
          mostrarNotificacion(
            true,
            "El prestador seleccionado no está disponible, seleccione una especialidad",
            "amarillo",
          );
          setAbrirDesplegableEspecialidades(true);
        }

        history.location.state = {};
        setPrestadorSeleccionadoExternamente(false);
      }
    };

    if (prestadorSeleccionadoExternamente) {
      manejarPrestadorPreseleccionado();
    }
  }, [
    prestadores,
    especialidades,
    history,
    prestadorSeleccionado,
    cargando,
    prestadorSeleccionadoExternamente,
  ]);

  const obtenerTurnos = async (config, prestador) => {
    let turnos = [];
    try {
      const response = await axios.get(
        `${urlAxioPP}Turnos/TurnosPrestadorFecha/?prestador=${prestador}&desde=${dayjs().format(
          "YYYY/MM/DD hh:mm",
        )}&hasta=${dayjs().add(3, "month").format("YYYY/MM/DD hh:mm")}`,
        config,
      );
      if (response.data.length !== 0) turnos = response.data;

      const turnosDisponibles = [];
      const turnosDadosMutual = [];

      turnos.forEach((turno) => {
        const diaSemana = dayjs(turno.fecha).get("d");
        const dia = diasSemana[diaSemana];
        let semanaTurno = dayjs(turno.fecha).week();
        let turnosPorSemana = {
          domingo: 0,
          lunes: 0,
          martes: 0,
          miercoles: 0,
          jueves: 0,
          viernes: 0,
          sabado: 0,
        };

        if (
          turno.libre &&
          !turno.cancelado &&
          !turno.entreTurno &&
          !turno.reservado
        ) {
          turnosDisponibles.push(turno);
        }

        let turnosSemana = turnosDadosMutual.find(
          (turno) => turno.semana === semanaTurno,
        );
        if (!turnosSemana) {
          turnosPorSemana[dia] += 1;
          turnosDadosMutual.push({
            semana: semanaTurno,
            ...turnosPorSemana,
            totalTurnosAsignadosMutual: 1,
          });
        } else {
          if (turno.mutual === usuario.mutual) {
            turnosSemana = {
              ...turnosSemana,
              [dia]: turnosSemana[dia] + 1,
              totalTurnosAsignadosMutual:
                turnosSemana.totalTurnosAsignadosMutual + 1,
            };
            turnosDadosMutual[
              turnosDadosMutual.findIndex(
                (turno) => turno.semana === semanaTurno,
              )
            ] = turnosSemana;
          }
        }
      });

      return { turnosDadosMutual, turnosDisponibles };
    } catch (error) {
      throw new Error(
        "Error al obtener los turnos disponibles: " + error.message,
      );
    }
  };

  const filtrarTurnosPorFechaYHora = (turnos) => {
    return turnos.filter(
      (turno) =>
        dayjs(turno.fecha).isSame(dayjs()) ||
        (dayjs(turno.fecha).isAfter(dayjs()) &&
          (dayjs().format("YYYY-MM-DD") !==
            dayjs(turno.fecha).format("YYYY-MM-DD") ||
            (dayjs().format("YYYY-MM-DD") ===
              dayjs(turno.fecha).format("YYYY-MM-DD") &&
              dayjs(turno.hora).format("HH:mm") >
                dayjs().add(3, "hour").format("HH:mm")))),
    );
  };

  const filtrarTurnosPorRestricciones = (
    turnos,
    atiende,
    turnosDadosMutual,
  ) => {
    return turnos.filter((turno) => {
      if (atiende.length === 0) {
        return true;
      } else {
        const diaSemana = dayjs(turno.fecha).get("d");
        const cantidadTurnosDia =
          atiende[0][diasSemana[diaSemana].toLowerCase()];
        const turnosOcupadosDia = turnosDadosMutual.find(
          (turnoMutual) => turnoMutual.semana === dayjs(turno.fecha).week(),
        )[diasSemana[diaSemana].toLowerCase()];
        return turnosOcupadosDia < cantidadTurnosDia;
      }
    });
  };

  const obtenerFechasTurnos = (turnosFiltrados) => {
    const fechasTurnos = borrarObjetosDuplicados(turnosFiltrados, "fecha", true)
      .filter((turno) => turno)
      .map((turno) => ({
        fecha: turno,
      }));
    return fechasTurnos;
  };

  const obtenerProximosTurnos = (
    fechasTurnos,
    horarios,
    turnosFiltradosPorRestricciones,
  ) => {
    const turnosProximos = [];
    fechasTurnos.forEach((fecha) => {
      const diaSemana = dayjs(fecha.fecha).get("d");
      const fechaTurno = dayjs(fecha.fecha).format("YYYY-MM-DD");
      const cantTurnos = turnosFiltradosPorRestricciones.filter((turno) =>
        dayjs(turno.fecha).isSame(dayjs(fecha.fecha)),
      ).length;
      if (
        (horarios[diasSemana[diaSemana].toLowerCase() + "MDe"] !== "" &&
          horarios[diasSemana[diaSemana].toLowerCase() + "MHa"]) ||
        (horarios[diasSemana[diaSemana].toLowerCase() + "TDe"] !== "" &&
          horarios[diasSemana[diaSemana].toLowerCase() + "THa"] !== "")
      ) {
        turnosProximos.push({
          date: fechaTurno,
          cantTurnos: cantTurnos,
          textColor: "#ffffff",
          backgroundColor: "#0A9B40",
        });
      }
    });
    return turnosProximos;
  };

  const traerTurnosAgenda = async (config, prestador, horarios, atiende) => {
    try {
      const { turnosDadosMutual, turnosDisponibles } = await obtenerTurnos(
        config,
        prestador,
      );

      const turnosFiltradosPorFechaYHora =
        filtrarTurnosPorFechaYHora(turnosDisponibles);

      const turnosFiltradosPorRestricciones = filtrarTurnosPorRestricciones(
        turnosFiltradosPorFechaYHora,
        atiende,
        turnosDadosMutual,
      );

      const fechasTurnos = obtenerFechasTurnos(turnosFiltradosPorRestricciones);

      const turnosProximos = obtenerProximosTurnos(
        fechasTurnos,
        horarios,
        turnosFiltradosPorRestricciones,
      );
      if (turnosProximos.length !== 0) {
        setFechasFuturas(ordenarArrayObjetosByDate(turnosProximos, "date"));
        setFechaSeleccionada(
          ordenarArrayObjetosByDate(turnosProximos, "date")[0].date,
        );
        setTurnosDisponibles(
          ordenarArrayObjetosByDate(turnosFiltradosPorRestricciones, "hora"),
        );
      } else {
        mostrarNotificacion(
          true,
          "No hay turnos disponibles con el prestador seleccionado",
          "amarillo",
        );
      }
    } catch (error) {
      mostrarNotificacion(true, "Error: " + error.message, "rojo");
    }
  };

  const traerHorariosAtencion = async (prestador) => {
    let horarios = null;
    let atiende = [];

    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    const servicio = await axios
      .get(`${urlAxioPP}Servicios`, config)
      .then((response) => {
        if (response.data.length !== 0) {
          return response.data[0];
        } else {
          return null;
        }
      });

    try {
      const [horariosResponse, atiendeResponse] = await Promise.all([
        axios.get(`${urlAxioPP}PrestadoresHorarios/${prestador}`, config),
        axios.get(
          `${urlAxioPP}Prestadores/RestriccionesPorMutual/${prestador}`,
          config,
        ),
      ]);

      if (
        horariosResponse.data.filter(
          (horario) => horario.prestador === prestador,
        ).length > 0
      ) {
        horarios = horariosResponse.data.filter(
          (horario) => horario.prestador === prestador,
        );
      }
      atiende = atiendeResponse.data.filter((a) => a.mutual === usuario.mutual);

      if (!horarios || !horarios[0]?.prestador) {
        mostrarNotificacion(
          true,
          "El prestador seleccionado no tiene un horario definido",
          "rojo",
        );
      } else {
        await traerTurnosAgenda(config, prestador, horarios[0], atiende);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al intentar consultar los horarios disponibles del prestador",
        "rojo",
      );
    }
  };

  const actualizarTurno = async () => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${usuario.token}` },
      };

      if (turnoSeleccionado) {
        const actualizarTurnoResponse = await axios.patch(
          `${urlAxioPP}Turnos/DarTurno/${turnoSeleccionado.codigo}`,
          {
            codigo: turnoSeleccionado.codigo,
            paciente: usuario.codigo,
            mutual: usuario.mutual,
            // estudio: 0,
            prestador: prestadorSeleccionado,
            telemedicina: turnoSeleccionado.telemedicina,
            observaciones: "Turno reservado via web por el paciente",
          },
          config,
        );
        if (actualizarTurnoResponse.status === 200) {
          mostrarNotificacion(
            true,
            "El turno se reservó correctamente",
            "verde",
          );

          togleAbrirCerrarConfirmarReserva(true);
          setFechaSeleccionada("");
          setTurnosDisponibles([]);
          setAbrirModalPostReserva(true);
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar reservar el turno",
            "rojo",
          );
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const verificarInasistenciasPorEspecialidad = (especialidad) => {
    const turnosPasados = turnosPaciente;
    let inasistidos = 0;

    turnosPasados.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") >=
            dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isAfter(new dayjs().subtract(2, "month")) &&
          dayjs(turno.fecha).isBefore(new dayjs()))
      ) {
        if (turno.especialidad === especialidad && turno.asistio === false) {
          inasistidos += 1;
        }
      }
    });

    return inasistidos;
  };

  const verificarTurnoConPrestadorPendiente = (prestador) => {
    const turnosFuturos = turnosPaciente;
    let turnoPendiente = false;

    turnosFuturos.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") <=
            dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isBefore(new dayjs().add(2, "month")) &&
          dayjs(turno.fecha).isAfter(new dayjs()))
      ) {
        if (turno.prestadorCod === prestador) {
          turnoPendiente = true;
        }
      }
    });

    return turnoPendiente;
  };

  const VerificarInasistenciasPorEspecialidad = (especialidad) => {
    const inasistidos = verificarInasistenciasPorEspecialidad(especialidad);

    setMostrarTurnoPrestadorReservado(false);
    if (inasistidos > 1) {
      setFechasFuturas([]);
      setMostrarInasisEspecilidad(true);
    } else {
      setMostrarInasisEspecilidad(false);
    }
  };

  const VerificarTurnoConPrestadorPendiente = (prestador) => {
    const turnoPendiente = verificarTurnoConPrestadorPendiente(prestador);

    if (turnoPendiente) {
      setFechasFuturas([]);
      setMostrarTurnoPrestadorReservado(true);
    } else {
      setMostrarTurnoPrestadorReservado(false);
      traerHorariosAtencion(prestador);
    }
  };

  const ordenarPrestadoresPorProximoTurno = (prestadores) => {
    return [...prestadores].sort((a, b) => {
      const tieneFechaA = Boolean(a.fechaProximoTurno);
      const tieneFechaB = Boolean(b.fechaProximoTurno);

      if (tieneFechaA && !tieneFechaB) return -1;
      if (!tieneFechaA && tieneFechaB) return 1;

      if (tieneFechaA && tieneFechaB) {
        const fechaA = dayjs(a.fechaProximoTurno);
        const fechaB = dayjs(b.fechaProximoTurno);

        if (fechaA.isBefore(fechaB)) {
          return -1;
        } else if (fechaA.isAfter(fechaB)) {
          return 1;
        }
      }

      const nombreA = a.nombre || a.text || "";
      const nombreB = b.nombre || b.text || "";
      return nombreA.localeCompare(nombreB);
    });
  };

  const handleChangeSelect = (value, select) => {
    setCargando(true);
    switch (select) {
      case "Especialidad":
        setEspecialidadSeleccionada(value);
        if (value !== -1) {
          setListadoPrestadores(
            filtrarPrestadoresPorEspecialidad(prestadores, value),
          );
          setAbrirDesplegablePrestadores(true);
        } else {
          setListadoPrestadores(ordenarPrestadoresPorProximoTurno(prestadores));
        }
        setPrestadorSeleccionado(-1);
        setFechasFuturas([]);
        if (value === MOSTRAR_TODOS_ESPECIALIDADES) {
          setMostrarTurnoPrestadorReservado(false);
          setMostrarInasisEspecilidad(false);
        } else {
          VerificarInasistenciasPorEspecialidad(value);
        }
        break;
      case "Profesional":
        setPrestadorSeleccionado(value);
        if (especialidadSeleccionada === MOSTRAR_TODOS_ESPECIALIDADES) {
          const prestadorEncontrado = prestadores.find(
            (prestador) => prestador.codigo === value,
          );
          const especialidadPrestador = prestadorEncontrado?.especialidad;
          const inasistidos = verificarInasistenciasPorEspecialidad(
            especialidadPrestador,
          );

          setMostrarTurnoPrestadorReservado(false);
          if (inasistidos > 1) {
            setFechasFuturas([]);
            setMostrarInasisEspecilidad(true);
            break;
          }

          setMostrarInasisEspecilidad(false);
        }
        VerificarTurnoConPrestadorPendiente(value);
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
    setCargando(false);
  };

  const handleChangeFecha = (value) => {
    setFechaSeleccionada(value);
  };

  const togleAbrirCerrarConfirmarReserva = (confirma = false) => {
    if (abrirModalConfirmarReserva && !confirma) {
      setTurnoSeleccionado({});
    }
    setAbrirModalConfirmarReserva(!abrirModalConfirmarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    setTurnoSeleccionado(turno);
    togleAbrirCerrarConfirmarReserva();
  };

  const handleClickConfirmarHacerReserva = async () => {
    setCargando(true);
    await actualizarTurno();
    setCargando(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "3518150850";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      "",
    );
  };

  const handlePostTurnoReservado = (accion) => {
    setTurnoSeleccionado({});
    setAbrirModalPostReserva(false);
    switch (accion) {
      case "nuevoTurno":
        window.location.reload();
        break;
      case "turnosPaciente":
        history.push({ pathname: "/portal/Turnos" });
        break;
      default:
        history.push({ pathname: "/portal/Turnos" });
        break;
    }
  };

  const renderTurnos = () => {
    let turnos = turnosDisponibles.filter(
      (turno) =>
        dayjs(turno.fecha).format("YYYY-MM-DD") ===
        dayjs(fechaSeleccionada).format("YYYY-MM-DD"),
    );

    return turnos.map((turno) => (
      <Column
        container
        xs={6}
        sm={4}
        md={3}
        lg={3}
        key={turno.codigo}
        className="reserva-turno-col"
      >
        <StyledButton
          className="reserva-turno-slot"
          onClick={() => handleClickSeleccionarTurno(turno)}
        >
          {dayjs(turno.hora).format("HH:mm")}
        </StyledButton>
      </Column>
    ));
  };

  return (
    <>
      <div slot="content">
        {prestadorSeleccionadoExternamente &&
          prestadorSeleccionado !== -1 &&
          fechasFuturas.length === 0 &&
          !mostrarInasisEspecilidad &&
          !mostrarTurnoPrestadorReservado && (
            <Container>
              <Row
                container
                width="100%"
                style={{ justifyContent: "center", marginBottom: "20px" }}
              >
                <Column xs={12}>
                  <Typography
                    level="body-lg"
                    style={{
                      textAlign: "center",
                      color: "var(--portal-text-primary)",
                      fontWeight: "bold",
                    }}
                  >
                    Cargando horarios disponibles para el prestador
                    seleccionado...
                  </Typography>
                </Column>
              </Row>
            </Container>
          )}

        <Container className="reserva-selectores-wrapper">
          <Row container width="100%" className="reserva-selectores-row">
            {!cargando &&
              especialidades.length > 0 &&
              !(
                prestadorSeleccionadoExternamente &&
                prestadorSeleccionado !== -1 &&
                !mostrarInasisEspecilidad &&
                !mostrarTurnoPrestadorReservado
              ) && (
                <Column xs={12} md={6}>
                  <IonItem className="amarillo-sol reserva-select-item">
                    <CustomDesplegable
                      array={especialidades}
                      value={especialidadSeleccionada}
                      displayValue={especialidadVisibleEnSelector}
                      handleChange={handleChangeSelect}
                      mostrarTodos={true}
                      mostrarTodosValue={MOSTRAR_TODOS_ESPECIALIDADES}
                      mostrarSearch={true}
                      placeholder="Seleccione una especialidad..."
                      label="🩺 Especialidades"
                      id="Especialidad"
                      isOpen={abrirDesplegableEspecialidades}
                      setIsOpen={setAbrirDesplegableEspecialidades}
                      variant="plain"
                    />
                  </IonItem>
                </Column>
              )}
            {especialidadSeleccionada !== -1 &&
              !(
                prestadorSeleccionadoExternamente &&
                prestadorSeleccionado !== -1 &&
                !mostrarInasisEspecilidad &&
                !mostrarTurnoPrestadorReservado
              ) && (
                <Column xs={12} md={6}>
                  <IonItem className="amarillo-sol reserva-select-item">
                    <CustomDesplegable
                      array={listadoPrestadores}
                      value={prestadorSeleccionado}
                      handleChange={handleChangeSelect}
                      mostrarTodos={false}
                      mostrarSearch={true}
                      placeholder="Seleccione un profesional..."
                      label="👨‍⚕️ Profesionales"
                      id="Profesional"
                      isOpen={abrirDesplegablePrestadores}
                      setIsOpen={setAbrirDesplegablePrestadores}
                      variant="plain"
                    />
                  </IonItem>
                </Column>
              )}
          </Row>
        </Container>

        {prestadorActual?.imageSrc && (
          <Container className="reserva-prestador-foto-wrapper">
            <Row container width="100%">
              <Column xs={12} md={6}>
                <div className="reserva-prestador-foto-card">
                  <div className="reserva-prestador-foto-frame">
                    <img
                      src={prestadorActual.imageSrc}
                      alt={prestadorActual.nombre}
                      className="reserva-prestador-foto"
                    />
                  </div>
                  <div className="reserva-prestador-foto-info">
                    <Typography
                      level="title-sm"
                      className="reserva-prestador-foto-nombre"
                    >
                      {prestadorActual.nombre}
                    </Typography>
                    <Typography
                      level="body-sm"
                      className="reserva-prestador-foto-detalle"
                    >
                      {obtenerNombreEspecialidadPrestador(prestadorActual)}
                    </Typography>
                  </div>
                </div>
              </Column>
            </Row>
          </Container>
        )}

        {(mostrarNotaWebMutual || mostrarNotaWebPrestador) && (
          <Container className="reserva-notas-wrapper">
            {mostrarNotaWebMutual && (
              <Column xs={12} className="reserva-nota-col">
                <IonCard className="reserva-nota-card reserva-nota-mutual-card">
                  <IonCardContent>
                    <Typography level="body-sm" className="reserva-nota-texto">
                      {notaWebMutual}
                    </Typography>
                  </IonCardContent>
                </IonCard>
              </Column>
            )}

            {mostrarNotaWebPrestador && (
              <Column xs={12} className="reserva-nota-col">
                <IonCard className="reserva-nota-card reserva-nota-prestador-card">
                  <IonCardContent>
                    <Typography level="body-sm" className="reserva-nota-texto">
                      {prestadorActual?.notaWeb}
                    </Typography>
                  </IonCardContent>
                </IonCard>
              </Column>
            )}
          </Container>
        )}

        {fechasFuturas.length > 0 && (
          <Container className="reserva-agenda-wrapper">
            <Row container className="reserva-agenda-grid">
              <Column xs={12} md={6} lg={6} className="reserva-calendario-col">
                <div className="reserva-calendario-panel">
                  <Typography level="title-md" className="reserva-bloque-title">
                    📅 Seleccioná una fecha
                  </Typography>
                  <CustomCalendar
                    onChange={(newSelectedDate) =>
                      handleChangeFecha(
                        dayjs(newSelectedDate).format("YYYY-MM-DD"),
                      )
                    }
                    minDate={dayjs(new dayjs())}
                    maxDate={dayjs(new dayjs()).add(3, "months")}
                    value={fechaSeleccionada}
                    highlightedDates={fechasFuturas}
                  />
                </div>
              </Column>

              {turnosDisponibles.length > 0 && (
                <Column xs={12} md={6} lg={6} className="reserva-horarios-col">
                  <div className="reserva-horarios-panel">
                    <div className="reserva-horarios-header">
                      <Typography
                        level="title-md"
                        className="reserva-bloque-title"
                      >
                        🕒 Horarios disponibles
                      </Typography>
                      <Typography
                        level="body-sm"
                        className="reserva-horarios-fecha"
                      >
                        {`${obtenerNombreDia(
                          dayjs(fechaSeleccionada).format("dddd"),
                        )} ${dayjs(fechaSeleccionada).format("DD")} de ${dayjs(
                          fechaSeleccionada,
                        ).format("MMMM, YYYY")}`}
                      </Typography>
                    </div>

                    <IonGrid className="reserva-turnos-grid">
                      <IonRow>{renderTurnos()}</IonRow>
                    </IonGrid>
                  </div>
                </Column>
              )}
            </Row>
          </Container>
        )}
      </div>

      {mostrarInasisEspecilidad && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No podes reservar un nuevo turno con esta especialidad
                  debido a que no asististe a 2 o mas turnos en los ultimos 2
                  meses para la especialidad que seleccionaste. Estaremos
                  encantados de atenderte y brindarte la mejor atención
                  personalizada si te pones en contacto. Podes presionar los
                  botones inferiores para copiar el numero de telefono fijo o
                  llevarte a nuestro chat de Whatsapp.
                </h4>
              </IonCardContent>
              <IonRow>
                <IonCol>
                  <StyledButton
                    className="verde"
                    expand="block"
                    // href="https://api.whatsapp.com/send?phone=5493518150850&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20poder%20sacar%20un%20turno%20para%20tratamientos%20estéticos"
                  >
                    <IonIcon icon={logoWhatsapp} />
                    <IonLabel>WhatsApp</IonLabel>
                  </StyledButton>
                </IonCol>
                <IonCol>
                  <StyledButton
                    className="blanco"
                    expand="block"
                    onClick={handleClickCopiarTelefono}
                  >
                    <IonIcon icon={callSharp} />
                    <IonLabel>Telefono</IonLabel>
                  </StyledButton>
                </IonCol>
              </IonRow>
            </IonCard>
          </IonCol>
        </IonRow>
      )}
      {mostrarTurnoPrestadorReservado && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No esta permitido sacar un segundo turno para un mismo
                  prestador
                </h4>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      )}

      <DialogoConfirmacion
        titulo="Reservar turno"
        texto={`Ha seleccionado el turno con el/la profesional ${
          turnoSeleccionado.prestadorNom
        }, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el día ${dayjs(turnoSeleccionado.fecha).format(
          "DD/MM/YYYY",
        )}, a las ${dayjs(turnoSeleccionado.hora).format(
          "HH:mm",
        )}, ¿es esto correcto?`}
        open={abrirModalConfirmarReserva}
        setOpen={setAbrirModalConfirmarReserva}
        handleClickConfirmar={handleClickConfirmarHacerReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No, Revisar"
        textoBotonSi="Si, Confirmar"
      />

      <DialogoConfirmacion
        titulo="Turno reservado"
        texto={`Se ha reservado exitosamente el turno con el/la profesional ${
          turnoSeleccionado.prestadorNom
        }, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el día ${dayjs(turnoSeleccionado.fecha).format(
          "DD/MM/YYYY",
        )}, a las ${dayjs(turnoSeleccionado.hora).format("HH:mm")}`}
        open={abrirModalPostReserva}
        setOpen={setAbrirModalPostReserva}
        handleClickConfirmar={() => handlePostTurnoReservado("nuevoTurno")}
        handleClickCancelar={() => handlePostTurnoReservado("turnosPaciente")}
        variantBotonNo="solid"
        colorBotonNo="primary"
        variantBotonSi="solid"
        colorBotonSi="primary"
        variantDialog="plain"
        colorDialogo="success"
        textoBotonNo="Consultar mis turnos"
        textoBotonSi="Reservar nuevo turno"
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
